export enum RouterStatusEnum {
    Deleted,
    Available,
    Rented,
    Damaged
}
